@if (!exportMode) {
<div class="education__edit-button-div">
  @if (editMode) {
    <button
      mat-raised-button
      class="education__edit-btn education__edit-btn--text"
      (click)="onCancelEdit()"
    >
      {{ 'general.cancel' | translate }}
    </button>

    <button
      mat-icon-button
      class="education__edit-btn education__edit-btn--icon"
      (click)="onCancelEdit()"
      [attr.aria-label]="'general.cancel' | translate"
    >
      <mat-icon>close</mat-icon>
    </button>
  }
  <button
    mat-flat-button
    class="education__edit-btn education__edit-btn--text"
    [disabled]="editMode && (!formChanged || form.invalid || isSaving)"
    (click)="onToggleEdit()"
  >
    {{ editMode ? ('general.save' | translate) : ('general.edit' | translate) }}
  </button>

  <button
    mat-icon-button
    class="education__edit-btn education__edit-btn--icon"
    [disabled]="editMode && (!formChanged || form.invalid || isSaving)"
    (click)="onToggleEdit()"
    [attr.aria-label]="(editMode ? ('general.save' | translate) : ('general.edit' | translate))"
  >
    <mat-icon>{{ editMode ? 'save' : 'edit' }}</mat-icon>
  </button>
</div>
}

<form [formGroup]="form">
  @if (educationArray.length > 0) {
    <div formArrayName="ausbildung" class="education__wrapper">
      @for (group of educationArray.controls; track group; let idx = $index) {
        <mat-card class="education__card" [class.education__card--export]="exportMode && !twoPagerMode">
          @if (exportMode && !twoPagerMode) {
            <mat-checkbox
              [checked]="selectedExportIds.includes(group.value.uuid || idx.toString())"
              (change)="toggleExportSelection(group.value.uuid || idx.toString(), $event.checked)"
            ></mat-checkbox>
          }
          <div [formGroupName]="idx" class="education__content">
            <div class="education__field">
              @if (!editMode) {
                <div class="education__label-row">
                  <mat-label class="education__question">{{ 'education.from' | translate }}</mat-label>
                  <app-field-warning [finding]="entryFinding(idx, 'beginn')"></app-field-warning>
                </div>
                <p>{{ group.value.beginn | date: 'MM/yyyy' }}</p>
              } @else {
                <mat-form-field>
                  <mat-label class="education__question">{{ 'education.from' | translate }}</mat-label>
                  <input
                    required
                    matInput
                    [matDatepicker]="datepicker"
                    formControlName="beginn"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="datepicker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #datepicker>
                    <mat-datepicker-actions>
                      <button mat-button matDatepickerCancel>{{ 'general.cancel' | translate }}</button>
                      <button mat-flat-button matDatepickerApply>{{ 'general.apply' | translate }}</button>
                    </mat-datepicker-actions>
                  </mat-datepicker>
                  @if (group.get('beginn')?.invalid) {
                    <mat-error>{{ 'general.errors.required' | translate }}</mat-error>
                  }
                </mat-form-field>
              }
            </div>

            <div class="education__field">
              @if (!editMode) {
                <div class="education__label-row">
                  <mat-label class="education__question">{{ 'education.trainingInstitution' | translate }}</mat-label>
                  <app-field-warning [finding]="entryFinding(idx, 'ausbildungseinrichtung')"></app-field-warning>
                </div>
                <p>{{ group.value.ausbildungseinrichtung }}</p>
              } @else {
                <mat-form-field>
                  <mat-label class="education__question">{{ 'education.trainingInstitution' | translate }}</mat-label>
                  <input
                    required
                    matInput
                    type="text"
                    formControlName="ausbildungseinrichtung"
                    [maxlength]="LIMITS.SHORT_LABEL"
                    (keypress)="onKeyPress($event)"
                  />
                  <mat-hint align="end">{{ (group.get('ausbildungseinrichtung')?.value?.length || 0) }}/{{ LIMITS.SHORT_LABEL }}</mat-hint>
                  @if (group.get('ausbildungseinrichtung')?.hasError('required')) {
                    <mat-error>{{ 'general.errors.required' | translate }}</mat-error>
                  }
                  @if (group.get('ausbildungseinrichtung')?.hasError('maxlength')) {
                    <mat-error>{{ 'general.validation.maxLength' | translate: { max: LIMITS.SHORT_LABEL } }}</mat-error>
                  }
                </mat-form-field>
              }
            </div>

            <div class="education__field">
              @if (!editMode) {
                <div class="education__label-row">
                  <mat-label class="education__question">{{ 'education.trainingCourse' | translate }}</mat-label>
                  <app-field-warning [finding]="entryFinding(idx, 'ausbildungsgang')"></app-field-warning>
                </div>
                <p>{{ group.value.ausbildungsgang }}</p>
              } @else {
                <mat-form-field>
                  <mat-label class="education__question">{{ 'education.trainingCourse' | translate }}</mat-label>
                  <input required matInput type="text" formControlName="ausbildungsgang"
                         [maxlength]="LIMITS.SHORT_LABEL"
                         (keypress)="onKeyPress($event)"/>
                  <mat-hint align="end">{{ (group.get('ausbildungsgang')?.value?.length || 0) }}/{{ LIMITS.SHORT_LABEL }}</mat-hint>
                  @if (group.get('ausbildungsgang')?.hasError('required')) {
                    <mat-error>{{ 'general.errors.required' | translate }}</mat-error>
                  }
                  @if (group.get('ausbildungsgang')?.hasError('maxlength')) {
                    <mat-error>{{ 'general.validation.maxLength' | translate: { max: LIMITS.SHORT_LABEL } }}</mat-error>
                  }
                </mat-form-field>
              }
            </div>

            <div class="education__field">
              @if (!editMode) {
                <div class="education__label-row">
                  <mat-label class="education__question">{{ 'education.diploma' | translate }}</mat-label>
                  <app-field-warning [finding]="entryFinding(idx, 'abschluss')"></app-field-warning>
                </div>
                <p>{{ group.value.abschluss }}</p>
              } @else {
                <mat-form-field>
                  <mat-label class="education__question">{{ 'education.diploma' | translate }}</mat-label>
                  <input required matInput type="text" formControlName="abschluss" [maxlength]="LIMITS.SHORT_LABEL" (keypress)="onKeyPress($event)"/>
                  <mat-hint align="end">{{ (group.get('abschluss')?.value?.length || 0) }}/{{ LIMITS.SHORT_LABEL }}</mat-hint>
                  @if (group.get('abschluss')?.hasError('required')) {
                    <mat-error>{{ 'general.errors.required' | translate }}</mat-error>
                  }
                  @if (group.get('abschluss')?.hasError('maxlength')) {
                    <mat-error>{{ 'general.validation.maxLength' | translate: { max: LIMITS.SHORT_LABEL } }}</mat-error>
                  }
                </mat-form-field>
              }
            </div>

            <div class="education__field">
              @if (!editMode) {
                <mat-label class="education__question">{{ 'education.until' | translate }}</mat-label>
                @if (!group.value.ende) {
                  <p>{{ 'education.untilToday' | translate }}</p>
                } @else {
                  <p>{{ group.value.ende | date: 'MM/yyyy' }}</p>
                }
              } @else {
                @if (!group.get('stillWorking')?.value) {
                  <mat-form-field>
                    <mat-label class="education__question">{{ 'education.until' | translate }}</mat-label>
                    <input
                      matInput
                      [matDatepicker]="picker"
                      formControlName="ende"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="picker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #picker>
                      <mat-datepicker-actions>
                        <button mat-button matDatepickerCancel>
                          {{ 'general.cancel' | translate }}
                        </button>
                        <button mat-flat-button matDatepickerApply>
                          {{ 'general.apply' | translate }}
                        </button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                }

                <mat-checkbox class="education__check-still-working" [disableRipple]="true"
                              formControlName="stillWorking">
                  {{ 'education.untilToday' | translate }}
                </mat-checkbox>
              }
            </div>

            <div class="education__field">
              @if (!editMode) {
                <div class="education__label-row">
                  <mat-label class="education__question">{{ 'education.location' | translate }}</mat-label>
                  <app-field-warning [finding]="entryFinding(idx, 'ort')"></app-field-warning>
                </div>
                <p>{{ group.value.ort }}</p>
              } @else {
                <mat-form-field>
                  <mat-label class="education__question">{{ 'education.location' | translate }}</mat-label>
                  <input matInput type="text" formControlName="ort" required [maxlength]="LIMITS.LOCATION" (keypress)="onKeyPress($event)"/>
                  <mat-hint align="end">{{ (group.get('ort')?.value?.length || 0) }}/{{ LIMITS.LOCATION }}</mat-hint>
                  @if (group.get('ort')?.hasError('required')) {
                    <mat-error>{{ 'general.errors.required' | translate }}</mat-error>
                  }
                  @if (group.get('ort')?.hasError('maxlength')) {
                    <mat-error>{{ 'general.validation.maxLength' | translate: { max: LIMITS.LOCATION } }}</mat-error>
                  }
                </mat-form-field>
              }
            </div>

            <div class="education__field">
              <mat-label class="education__question">{{ 'education.successful' | translate }}</mat-label>
              @if (!editMode) {
                <p>
                  {{ group.value.abschlussErreicht ? ('education.yes' | translate) : ('education.no' | translate) }}
                </p>
              } @else {
                <div>
                  <mat-checkbox
                    formControlName="abschlussErreicht"
                    name="fertig-{{ idx }}"
                  ></mat-checkbox>
                  <mat-label>{{ 'education.withSuccessfulCompletion' | translate }}</mat-label>
                </div>
              }
            </div>

            @if (editMode) {
              <div class="education__delete-button">
                <button
                  mat-mini-fab
                  color="primary"
                  (click)="openDeleteModal(idx)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            }
          </div>
        </mat-card>
      }
    </div>

    @if (editMode) {
      <div class="education__add-button">
        <button
          mat-flat-button
          (click)="addEducationForm()"
        >
          <mat-icon>add</mat-icon>
          {{ 'education.button.newTraining' | translate }}
        </button>
      </div>
    }
  } @else {
    <mat-card appearance="outlined" class="education__no-data">
      <mat-card-content>{{ 'education.noTraining' | translate }}</mat-card-content>
    </mat-card>
  }
</form>

<!-- NP20-822: Bei vielen Einträgen ist der Weg nach oben weit; Abbrechen und Speichern
     kleben beim Bearbeiten am unteren Rand und rasten am Ende des Abschnitts ein. -->
@if (editMode && !exportMode) {
  <div class="sticky-save" role="group" [attr.aria-label]="'general.sectionActionsEnd' | translate">
    <button mat-stroked-button type="button" (click)="onCancelEdit()">
      {{ 'general.cancel' | translate }}
    </button>
    <button mat-flat-button type="button" [disabled]="!formChanged || form.invalid || isSaving" (click)="onToggleEdit()">
      {{ 'general.save' | translate }}
    </button>
  </div>
}

<app-modal
  modalId="deleteEducation"
  [title]="'education.modal.title'"
  [text]="'education.modal.text'"
  [(visible)]="showModal"
  [showButtons]="true"
  (save)="delete(currentIdx)"
  [showClose]="true"
  [saveText]="'general.delete'"
></app-modal>
